import React, { Suspense } from "react"

import { useSelector, useDispatch } from "react-redux"

import { Provider } from 'react-native-paper';

import FullscreenLoading from "./components/fullscreen-loading"
import { setToken } from "./containers/public/reducers/authentication";

const Public = React.lazy(() => import("./containers/public/scene"))
const Private = React.lazy(() => import("./containers/private/scene"))

function App() {
    const dispatch = useDispatch()
    
    const { token } = useSelector(state => state["auth"])

    const logged = token

    if(logged) {
        const meta = JSON.parse(atob(token.split(".")[1]))
        if(Date.now() > (meta["exp"] * 1000)) {
            dispatch(setToken(null))
        }
    }

    return (
        <Provider>
            {
                logged ? 
                    <Suspense fallback={<FullscreenLoading/>}>
                        <Private/>
                    </Suspense>:
                    <Suspense fallback={<FullscreenLoading/>}>
                        <Public/>
                    </Suspense>
            }
        </Provider>
    )
}

export default App